import { Box, Skeleton } from '@mui/material'
import type { FC } from 'react'

import { unit } from '@hcr/ui'

export const InternalPointsExchangeNutshellLoading: FC = () => {
  return (
    <Box paddingTop={unit(3)}>
      <Skeleton height={unit(12)} variant='rectangular' />
    </Box>
  )
}
